/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Start_Time_Only_LabelInputs */



/**
* | output |
* | --- |
* | "Start Time Only" |
*
* @param {Timing_Sync_Start_Time_Only_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_start_time_only_label = /** @type {((inputs?: Timing_Sync_Start_Time_Only_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Start_Time_Only_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Heure de debut seulement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Startzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo ora di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Только время начала")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo hora de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅限开始时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間のみ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल प्रारंभ समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Somente o horário de início")
	return /** @type {LocalizedString} */ ("Start Time Only")
});